import { ApplicationInsights, IAutoExceptionTelemetry, ITelemetryItem } from '@microsoft/applicationinsights-web'

declare global {
  interface Window {
    applicationInsightsConnectionString?: string;
    applicationInsightsUserName?: string;
    applicationInsightsApplicationVersion?: string;
  }
}

const appInsights = new ApplicationInsights({
  config: {
    connectionString: window.applicationInsightsConnectionString,
  }
});


appInsights.loadAppInsights();

if (window.applicationInsightsUserName) {
  appInsights.setAuthenticatedUserContext(window.applicationInsightsUserName.replace(/[,;=| ]+/g, "_"));
}


if (window.applicationInsightsApplicationVersion) {
  // the first track needs to be manually set, not sure why
  appInsights.context.application.ver = window.applicationInsightsApplicationVersion;
  var applicationVersionTelemetryInitializer = (envelope: ITelemetryItem) => {
    appInsights.context.application.ver = window.applicationInsightsApplicationVersion ?? 'undefined';
  };
  appInsights.addTelemetryInitializer(applicationVersionTelemetryInitializer);
}

appInsights.trackPageView();
export default appInsights;

export class ErrorLogger {
  static logError(error: Error | string | unknown, properties?: { [key: string]: any }) {
    let exceptionTelemetry: Error | IAutoExceptionTelemetry;

    if (error instanceof Error) {
      exceptionTelemetry = error;
    } else {
      const callerStack = (new Error()).stack?.split('\n').slice(2) ?? [];

      if (typeof error === 'string') {
        exceptionTelemetry = {
          message: error,
          url: window.location.href,
          stackDetails: {obj: callerStack},
        } as IAutoExceptionTelemetry;
      } else {
        const errorTypeName = error?.constructor?.name || typeof error
        exceptionTelemetry = {
          message: errorTypeName,
          url: window.location.href,
          error: error,
          stackDetails: {obj: callerStack},
          typeName: errorTypeName
        } as IAutoExceptionTelemetry;
      }
    }

    appInsights.trackException({exception: exceptionTelemetry}, properties);

    console.warn("Error logged", {error: error, properties: properties});
  }
}
